import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';


let base = '/sstwebapi';
// let base = '';
let executionsNum = 0
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
//let base = process.env.NODE_ENV=="production"? 'http://api.training.wanghuolou.cn:82':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:5001':'';

//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:1004':'';

// 请求延时
axios.defaults.timeout = 60000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
        // if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
        if (storeTemp.state.token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }

        saveRefreshtime();

        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    Response => {
        if (Response.data.Status == 401 || Response.data.Status == 400) {
            var curTime = new Date()
            var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
            // // 在用户操作的活跃期内
            // if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
            //     return  refreshToken({token: window.localStorage.Token}).then((res) => {
            //         if (res.Success) {
            //             store.commit("saveToken", res.Response.token);
            //             var curTime = new Date();
            //             var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.Response.expiresIn));
            //             store.commit("saveTokenExpire", expiredate);
            //             error.config.__isRetryRequest = true;
            //             error.config.headers.Authorization = 'Bearer ' + res.Response.token;
            //             return axios(error.config);
            //         } else {
            //             ToLogin()
            //             return false;
            //         }
            //     });
            // } else {
                ToLogin()
            //     return false;
            // }
        } else if (Response.data.Status == 403) {
            Vue.prototype.$message({
                message: '失败！该操作无权限',
                type: 'error'
            });
            return null;
        } else if (Response.data.Status == 429) {
            Vue.prototype.$message({
                message: '刷新次数过多，请稍事休息重试！',
                type: 'error'
            });
            return null;
        } else if (Response.data.Status == 500) {
            setTimeout(function(){
                Vue.prototype.$message({
                    message: '服务器错误，请稍后重试！',
                    type: 'error'
                });
            },1000)
            return null;
        }
         if (Response.data.Message == 'token无效') {
            // setTimeout(function(){
            //     Vue.prototype.$message({
            //         message: '服务器错误501！',
            //         type: 'error'
            //     });
            // },500)
            // return null;
            ToLogin()
        }
        return Response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        console.log(error.config)
        if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){

            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });

            originalRequest._retry = true
            return null;
        }
        if (error.response) {
            if (error.response.status == 401|| Response.data.Status == 400) {
                // var curTime = new Date()
                // var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // // 在用户操作的活跃期内
                // if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                //     return  refreshToken({token: window.localStorage.Token}).then((res) => {
                //         if (res.Success) {
                //             // Vue.prototype.$message({
                //             //     message: 'refreshToken success! loading data...',
                //             //     type: 'success'
                //             // });
                //
                //             store.commit("saveToken", res.Response.token);
                //
                //             var curTime = new Date();
                //             var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.Response.expiresIn));
                //             store.commit("saveTokenExpire", expiredate);
                //
                //             error.config.__isRetryRequest = true;
                //             error.config.headers.Authorization = 'Bearer ' + res.Response.token;
                //             return axios(error.config);
                //         } else {
                //             // 刷新token失败 清除token信息并跳转到登录页面
                //             ToLogin()
                //             return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                //         }
                //     });
                // } else {
                //     // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                //     return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                // }

            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
            // 500
            if (error.response.status == 500) {
                setTimeout(function(){
                    Vue.prototype.$message({
                        message: '服务器错误，请稍后重试！',
                        type: 'error'
                    });
                },1000)
                return null;
            }
            // 501
            if (error.response.Message == token无效) {
                // setTimeout(function(){
                //     Vue.prototype.$message({
                //         message: '服务器错误501！',
                //         type: 'error'
                //     });
                // },500)
                // return null;
                ToLogin()
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);

const ToLogin = params => {
    var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
    );
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('NavigationBar');

    var routerGo = router.currentRoute.fullPath.substring(0,6)
    if(routerGo == "/login"){
    }else{
        if(user && user.UserType == 2) {
            if(executionsNum < 1) {
                Vue.prototype.$message({
                    message: '页面已过期，请关闭当前页面！',
                    type: 'error'
                });
                executionsNum++
            }
        } else {
            window.localStorage.removeItem('user');
            router.replace({
                path: "/login",
                query: {redirect: router.currentRoute.fullPath}
            });
            window.location.reload()
        }
    }
    // router.replace({
    //     path: "/login",
    //     query: {redirect: router.currentRoute.fullPath}
    // });
    return false;  //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
};


export const BaseApiUrl =base;

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount=1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime=nowtime>expiretime ? nowtime:expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    }else {
        window.localStorage.refreshtime = new Date(-1);
    }
};



// 登录获取token
export const requestLogin = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/login/jwttoken`, {params: params}).then(res => res.data);
};

// 加密登录获取token
export const jwttokenCrypto = params => {
    // params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/login/jwttokenCrypto`,  params);
};

// 获取图形验证码
export const captchaImage = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/captcha/captchaImage`, {params: params}).then(res => res.data);
};

//刷新token
export const refreshToken = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/login/RefreshToken`, {params: params}).then(res => res.data);
};

// 社消平台跳转免登录获取token
export const ticketLogin = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/login/ticketLogin`, {params: params}).then(res => res.data);
};

//首页
//获取报名人数的图表数据
export const examenrollCountGroupByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/ExamenrollCountGroupByDate`, {params: params});
};
//根据行政区获取报名人数的图表数据
export const examenrollCountGroupByDateByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/ExamenrollCountGroupByDateByID`, {params: params});
};

//获取考试项目报名人数统计
export const examenrollCountGroupByProjectName = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/ExamenrollCountGroupByProjectName`, {params: params});
};
//根据行政区获取考试项目报名人数统计
export const examenrollCountGroupByProjectNameByID = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/ExamenrollCountGroupByProjectNameByID`, {params: params});
};

// 社会单位总数及学习中数量
export const getUnitsAndCertificatesResponse = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/getUnitsAndCertificatesResponse`, {params: params});
};

// 下级社会单位总数及学习中数量
export const getUnitsAndCertificatesResponseByID = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/getUnitsAndCertificatesResponseByID`, {params: params});
};

// 下级城市/地区的社会单位、持证总数、证书达标数列表
export const getProportionCertificateHolders = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetProportionCertificateHolders`, {params: params});
};

// 下级城市/地区的持证总数统计
export const getProportionCertificateHoldersByID = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetProportionCertificateHoldersByID`, {params: params});
};

// 社会单位持证统计分析
export const getSocialUnitCertificateHoldersStatistics = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetSocialUnitCertificateHoldersStatistics`, {params: params});
};

// 待监管单位
export const getHomeSocialUnitStatistics = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetHomeSocialUnitStatistics`, {params: params});
};

// 地图滑上社会单位，学习中，取证，待监管数量
export const getUnitsAndCertificatesSingleResponseByID = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/getUnitsAndCertificatesSingleResponseByID`, {params: params});
};

//首页改版新接口
// 共用-获取地图上方滑上浮窗数据
export const getStudentLearnRecords = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetStudentLearnRecords`, {params: params});
};
// 共用-获取地图地标接口
export const getJsonFile = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeoJson/GetJsonFile`, {params: params});
};

// 概况
// 消防安全知识知晓率排名
export const getMaterialExamPaperRightRatio = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetMaterialExamPaperRightRatio`, {params: params});
};
// 获取待监管单位数/单位总数接口
export const getToBeSupervisedSocialUnitCount = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetToBeSupervisedSocialUnitCount`, {params: params});
};
// 本级概况
export const getTrainingExaminationCertificateStatistics = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetTrainingExaminationCertificateStatistics`, {params: params});
};
// 获取地图浮窗数据
export const getUnitAndSupervisionResponseStatistics = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndSupervisionResponseStatistics`, {params: params});
};
// 下辖概况
export const getTrainingExaminationCertificateByID = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetTrainingExaminationCertificateByID`, {params: params});
};
// 饼状图概况
export const getAgencyInfoPass = params =>  {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/getAgencyInfoPass`, {params: params});
};

// 报考情况
// 获取每日报考人数
export const getExamenrollCountGroupByDateByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/ExamenrollCountGroupByDateByID`, {params: params});
};
// 根据岗位/行业获取报考人数/应训人数
export const getTrainingCountGroupByTradeByIDByType = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/TrainingCountGroupByTradeByIDByType`, {params: params});
};
// 本级报考情况
export const getUnitAndRegistrationCountRateStatisticsByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndRegistrationCountRateStatisticsByID`, {params: params});
};
// 获取地图浮窗数据
export const getMapRegistrationRateResponseStatistics = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetMapRegistrationRateResponseStatistics`, {params: params});
};
// 下辖报考情况
export const getUnitAndRegistrationCountRateStatistics = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndRegistrationCountRateStatistics`, {params: params});
};

// 参训情况
// 获取每日参训人数
export const getAttendTrainingCountGroupByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/AttendTrainingCountGroupByDate`, {params: params});
};
// 根据岗位/行业获取参训人数/应训人数
export const getTrainingCountGroupByTradeByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/TrainingCountGroupByTradeByID`, {params: params});
};
// 本级参训情况
export const getCurrentLevelParticipationByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetCurrentLevelParticipationByID`, {params: params});
};
// 获取地图浮窗数据
export const getTrainingMap = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetTrainingMap`, {params: params});
};
// 下辖参训情况
export const getParticipatingJurisdictions = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetParticipatingJurisdictions`, {params: params});
};
// 参训人数概况
export const getTrainingCountByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetTrainingCountByID`, {params: params});
};
// 获取乡镇下辖单位概况明细
export const getParticipatingJurisdictionsRegion = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetParticipatingJurisdictionsRegion`, {params: params});
};

// 持证情况
// 获取每日取证人数
export const getCertificateCountGroupByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetCertificateCountGroupByDate`, {params: params});
};
// 根据岗位/行业获取持证人数/应训人数
export const getCertificateCountGroupByTradeByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/CertificateCountGroupByTradeByID`, {params: params});
};
// 本级持证情况
export const getCurrentLevelCertificateHoldingByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetCurrentLevelCertificateHoldingByID`, {params: params});
};
// 获取地图浮窗数据
export const getMapOfCertificateHolding = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetMapOfCertificateHolding`, {params: params});
};
// 下辖持证情况
export const getCertificateHoldingUnderTheJurisdiction = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetCertificateHoldingUnderTheJurisdiction`, {params: params});
};
// 持证人数概况
export const getCertificateCountByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Home/GetCertificateCountByID`, {params: params});
};


//系统管理
//用户管理
export const getUserListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/userInfo/getUserInfoListPage`, {params: params});
};

// 根据token获取用户详细信息
export const getUserByToken = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/userInfo/getUserInfoByToken`, {params: params}).then(res => res.data);
};

//新增用户信息
export const addUserInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/userInfo/addUserInfo`,  params);
};

//更新用户信息
export const updateUserInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/userInfo/updateUserInfo`,  params);
};

//删除用户信息
export const deleteUserInfo = params => {
    return axios.delete(`${base}/userInfo/deleteUserInfo`,  {params: params});
};

//发送修改密码手机短信验证码
export const sendModifyPasswordSMSVerificationCode = params => {
    return axios.post(`${base}/userInfo/sendModifyPasswordSMSVerificationCode`,  params);
};

//修改用户登录密码
export const modifyUserPassword = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/userInfo/modifyUserPassword`,  params);
};

//系统管理
//菜单权限管理

//根据用户ID获取路由树
export const getNavigationBar = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/menuPermissions/getNavigationBar`, {params: params}).then(res => res.data);
};

//根据角色ID获取路由树
export const getNavigationBarByRoleId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/menuPermissions/getNavigationBarByRoleId`, {params: params}).then(res => res.data);
}

//获取菜单树
export const getMenuTree = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/menuPermissions/getMenuTree`, {params: params});
};

//获取菜单权限树形列表
export const getMenuPermissionsTree = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/menuPermissions/getMenuPermissionsTree`, {params: params});
};

//新增菜单权限信息
export const addMenuPermissionsInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/menuPermissions/addMenuPermissionsInfo`,  params);
};

//更新菜单权限信息
export const updateMenuPermissionsInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/menuPermissions/updateMenuPermissionsInfo`,  params);
};

//删除菜单权限信息
export const deleteMenuPermissionsInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.delete(`${base}/menuPermissions/deleteMenuPermissionsInfo`,  {params:params});
};

//保存菜单权限分配
export const assignMenuPermissions = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/menuPermissions/assignMenuPermissions`,  params);
};

//通过角色获取菜单【无权限】
export const GetAssignMenuPermissionIdByRoleId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/menuPermissions/getAssignMenuPermissionIdByRoleId`, {params: params});
};


//系统管理
//角色管理

//根据组织结构ID获取角色信息集合
export const getRoleInfosByOrganizationInfoID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/roleInfo/getRoleInfoByName`, {params: params});
};

//获取角色信息分页列表
export const getRoleListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/roleInfo/getRoleInfoListPage`, {params: params});
};

//新增角色信息
export const addRoleInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/roleInfo/addRoleInfo`,  params);
};

//更新角色信息
export const updateRoleInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/roleInfo/updateRoleInfo`,  params);
};

//删除角色信息
export const deleteRoleInfo = params => {
    return axios.delete(`${base}/roleInfo/deleteRoleInfo`,  {params: params});
};

//系统管理
// 组织结构管理

//获取组织结构树
export const getOrganizationTree = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/departmentInfo/getDepartmentTree`, {params: params});
};

//新增组织结构信息
export const addOrganizationInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/departmentInfo/addDepartmentInfo`,  params);
};

//更新组织结构信息
export const updateOrganizationInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/departmentInfo/updateDepartmentInfo`,  params);
};

//删除组织结构信息
export const deleteOrganizationInfo = params => {
    return axios.delete(`${base}/departmentInfo/deleteDepartmentInfo`,  {params: params});
};
//获取组织机构已绑定的社会单位
export const getSocialUnitIdByDepartmentInfoId = params => {
    return axios.get(`${base}/socialUnit/getSocialUnitIdByDepartmentInfoId`, {params: params});
};
//获取组织机构可绑定的社会单位
export const getSocialUnitListByDepartmentInfoId = params => {
    return axios.get(`${base}/socialUnit/getSocialUnitListByDepartmentInfoId`, {params: params});
};
//组织机构绑定社会单位
export const departmentInfoBindSocialUnit = params => {
    return axios.get(`${base}/socialUnit/departmentInfoBindSocialUnit`, {params: params});
};

//系统管理
// 接口管理

//获取接口信息树形列表
export const getApiModulesInfoTree = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/apiModulesInfo/getApiModulesInfoTree`, {params: params});
};

//获取接口菜单树
export const getApiMenuTree = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/apiModulesInfo/getApiMenuTree`, {params: params});
};

//新增接口信息
export const addApiModulesInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/apiModulesInfo/addApiModulesInfo`,  params);
};

//更新接口信息
export const updateApiModulesInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/apiModulesInfo/updateApiModulesInfo`,  params);
};

//删除接口信息
export const deleteApiModulesInfo = params => {
    return axios.delete(`${base}/apiModulesInfo/deleteApiModulesInfo`,  {params: params});
};

//系统管理
// 数据权限管理

//获取全部数据权限信息列表
export const getAllDataPermissionsInfoList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/dataPermissionsInfo/getAllDataPermissionsInfoList`, {params: params});
};

//新增数据权限信息
export const addDataPermissionsInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/dataPermissionsInfo/addDataPermissionsInfo`,  params);
};

//更新数据权限信息
export const updateDataPermissionsInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/dataPermissionsInfo/updateDataPermissionsInfo`,  params);
};

//删除数据权限信息
export const deleteDataPermissionsInfo = params => {
    return axios.delete(`${base}/dataPermissionsInfo/deleteDataPermissionsInfo`,  {params: params});
};

//保存数据权限分配
export const assignDataPermissions = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/dataPermissionsInfo/assignDataPermissions`,  params);
};

//通过角色ID获取数据权限菜单【无权限】
export const getAssignDataPermissionIdByRoleId = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/dataPermissionsInfo/getAssignDataPermissionIdByRoleId`, {params: params});
};


//系统管理
// Task管理

export const getTaskListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/TasksQz/get`, {params: params});
};
export const removeTask = params => {
    return axios.delete(`${base}/TasksQz/delete`, {params: params});
};
export const editTask = params => {
    return axios.put(`${base}/TasksQz/put`, params);
};
export const addTask = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/TasksQz/post`, params);
};

export const startJob = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/TasksQz/StartJob`, {params: params});
};
export const stopJob = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/TasksQz/StopJob`, {params: params});
};
export const reCovery = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/TasksQz/ReCovery`, {params: params});
};

//系统管理
//操作日志

// 获取系统调用日志列表
export const getSystemLogList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/SystemManager/GetSystemLogList`, {params: params});
};


//通用设置
//审批流程管理

//获取审批流程信息分页列表
export const getApprovalProcessListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/GetApprovalProcessListPage`, {params: params});
};

//新增审批流程
export const addApprovalProcess = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/AddApprovalProcess`,  params);
};

//更新审批流程
export const updateApprovalProcess = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/UpdateApprovalProcess`,  params);
};

//根据审批流程ID 获取审批流程图
export const getApprovalProcessDiagramByApprovalProcessID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/GetApprovalProcessDiagramByApprovalProcessID`, {params: params});
};

//通用设置
//项目列表
export const getProjectList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/project/getProjectList`, {params: params});
};
export const getProjectListOther = params => {
    return axios.get(`${base}/project/getProjectList`, {params: params});
};
//项目配置
export const getProjectSettingsItemList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/project/getProjectSettingsItemList`, {params: params});
};
//添加项目配置
export const addProjectSettings = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/project/addProjectSettings`,  params);
};


//通用设置
//单位通知模板

//获取单位通知模板分页列表
export const getNoticeTemplateListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/notificeTemplate/getNoticeTemplateListPage`, {params: params});
};

//新增单位通知模板
export const addNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/notificeTemplate/addNoticeTemplate`,  params);
};

//更新单位通知模板
export const updateNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/notificeTemplate/updateNoticeTemplate`,  params);
};

//删除单位通知模板
export const deleteNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/notificeTemplate/deleteNoticeTemplate`,  params);
};

//获取对应状态列表
export const getNoticeTemplateType = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/GetNoticeTemplateType`, {params: params});
};

//通用设置
//学员通知模板

//获取学员通知模板分页列表
export const getStudentNoticeTemplateListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/GetStudentNoticeTemplateListPage`, {params: params});
};

//新增学员通知模板
export const addStudentNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/AddStudentNoticeTemplate`,  params);
};

//更新学员通知模板
export const updateStudentNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/UpdateStudentNoticeTemplate`,  params);
};

//删除学员通知模板
export const deleteStudentNoticeTemplate = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/DeleteStudentNoticeTemplate`,  params);
};


//通用设置
//展示信息

//获取展示信息分页集合
export const getShowInformationListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/showInfo/getShowInformationListPage`, {params: params});
};

//新增展示信息
export const addShowInformation = params => {
    params.ProjectId = parseInt( parseInt(window.localStorage.getItem('projectId')))
    return axios.post(`${base}/showInfo/addShowInformation`,  params);
};

//更新展示信息
export const updateShowInformation = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/showInfo/updateShowInformation`,  params);
};

//删除展示信息
export const deleteShowInformation = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/showInfo/deleteShowInformation`,  params);
};

//顶置/取消顶置展示信息
export const setTopShowInformation = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/showInfo/setTopShowInformation`,  params);
};

//通用设置
//轮播信息

//获取轮播信息分页集合
export const getCarouselInformationList = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/carouseInfo/getCarouselInformationList`, {params: params});
};

//新增轮播信息
export const addCarouselInformation = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/carouseInfo/addCarouselInformation`,  params);
};

//更新轮播信息
export const updateCarouselInformation = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/carouseInfo/updateCarouselInformation`,  params);
};

//删除轮播信息
export const deleteCarouselInformation = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/carouseInfo/deleteCarouselInformation`,  params);
};


//通用设置
//行政区域


//获取行政区信息列表
export const getAreaDictionaryList = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/areaDictionary/getAreaDictionaryList`, {params: params});
};


export const getAreaDictionaryListWithCode = params => {
    return axios.get(`${base}/areaDictionary/getAreaDictionaryListWithCode`, {params: params});
}
export const getAreaCityGeo4List = params => {
    return axios.get(`${base}/areaDictionary/getAreaCityGeo4List`, {params: params});
}


//新增行政区信息
export const addAreaDictionary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/AddAreaDictionary`,  params);
};

//更新行政区信息
export const updateAreaDictionary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/UpdateAreaDictionary`,  params);
};

//删除行政区信息
export const deleteAreaDictionary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/DeleteAreaDictionary`,  params);
};

//抓取行政区信息
export const grabAreaDictionary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/GrabAreaDictionary`,  params);
};


//通用设置
//数据字典信息

//获取数据字典信息列表
export const getDataDictionaryList = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/baseDictionary/getBaseDictionaryList`, {params: params});
};

//新增数据字典信息
export const addDataDictionary = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/baseDictionary/addBaseDictionary`,  params);
};

//更新数据字典信息
export const updateDataDictionary = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/baseDictionary/updateBaseDictionary`,  params);
};

//删除数据字典信息
export const deleteDataDictionary = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/baseDictionary/deleteBaseDictionary`,  params);
};

//根据id获取数据字典
export const getById = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/dataDictionary/getById`, {params: params});
};


// 考试项目 新增数据字典
export const saveDataDictionary = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/dataDictionary/saveDataDictionary`,  params);
};

//通用设置
//考试项目简介

//获取考试项目简介分页列表
export const getExamProjectExplainListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationProject/getExamProjectExplainListPage`, {params: params});
};

//新增考试项目简介
export const addExamProjectExplain = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/addExamProjectExplain`,  params);
};

//更新考试项目简介
export const updateExamProjectExplain = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/updateExamProjectExplain`,  params);
};

//删除考试项目简介
export const deleteExamProjectExplain = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/deleteExamProjectExplain`,  params);
};

//根据考试项目简介ID获取考试项目简介岗位行业关联息列表
export const getExamProjectExplainList = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationProject/getExamProjectExplainList`, {params: params});
};

//新增考试项目简介岗位行业关联息
export const addExamProjectExplainSTRelation = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/addExamProjectExplainSTRelation`,  params);
};


//通用设置
//APP版本信息

//获取APP版本信息分页列表
export const getAPPVersionInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/appVersion/getAppVersionList`, {params: params});
};

//新增APP版本信息
export const addAPPVersionInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/appVersion/addAppVersion`,  params);
};

export const addAPPVersionInfoLibrary1 = `${base}/appVersion/addAppVersion`;

//更新APP版本信息
export const updateAPPVersionInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/appVersion/updateAppVersion`,  params);
};

export const updateAPPVersionInfoLibrary1 = `${base}/CommonSettings/UpdateAPPVersionInfo`

//删除APP版本信息
export const deleteAPPVersionInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/appVersion/deleteAppVersion`,  params);
};

//通用设置
//其他设置

//获取其他设置
export const getCommonSetting = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/dataDictionary/getCommonSetting`, {params: params});
};

//获取允许删除单位人员数据
export const getDeletedStaffsAuthoritySetting = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/dataDictionary/getByNamespace`, {params: params});
};

//保存其他设置
export const setCommonSetting = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/setCommonSetting`,  params);
};

//保存其他设置
export const updateDeletedStaffsAuthoritySetting = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/updateDeletedStaffsAuthoritySetting`,  params);
};

//通用设置
//单位填报标准设置

//获取单位填报标准设置
export const getUnitFillingSetting = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/getUnitFillingSetting`, {params: params});
};

//保存单位填报标准设置
export const updateUnitFillCommonSetting = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/updateUnitFillCommonSetting`,  params);
};

//通用设置
//简报数据设置

//获取简报数据设置
export const getReportDataSetting = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/getReportDataSetting`, {params: params});
};

//查看简报数据设置
export const getReportDataSettingByBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/getReportDataSettingByBatch`, {params: params});
};

//新增/编辑简报数据设置
export const saveReportDataSettingByBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/saveReportDataSettingByBatch`,  params);
};

//删除简报数据设置
export const deletedReportDataSettingByBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/deletedReportDataSettingByBatch`, {params: params});
};

//启用/禁用简报数据设置
export const isEnableReportDataSettingForBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CommonSettings/isEnableReportDataSettingForBatch`,  params);
};

//主数据管理
//试题管理

//获取试题信息分页列表
export const getExaminationQuestionsListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationQuestions/getExaminationQuestionsListPage`, {params: params});
};

//根据教材ID获取试题分页集合
export const getExaminationQuestionsByTMIDListPageAsync = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationQuestions/getExaminationQuestionsByTMIDListPageAsync`, {params: params});
};

//新增试题信息
export const addExaminationQuestions = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationQuestions/addExaminationQuestions`,  params);
};

//编辑试题信息
export const updateExaminationQuestions = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationQuestions/updateExaminationQuestions`,  params);
};

//删除试题信息
export const deleteExaminationQuestions = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationQuestions/deleteExaminationQuestions`,  params);
};

//公开/私有试题信息
export const shareOrPrivateExaminationQuestions = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationQuestions/shareOrPrivateExaminationQuestions`,  params);
};

//建立教材与试题关联关系
export const relationTeachingExamination = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/relationTeachingExamination`,  params);
};

//取消教材与试题关联关系
export const delRelationTeachingExamination = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/delRelationTeachingExamination`,  params);
};

//转为字典试题审批
export const convertDictionaryExaminationQuestionsApproval = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/WorkFlow/ConvertDictionaryExaminationQuestionsApproval`,  params);
};

//变更字典试题审批
export const changeDictionaryExaminationQuestionsApproval = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/WorkFlow/ChangeDictionaryExaminationQuestionsApproval`,  params);
};

// 批量导入试题
// export const importExaminationQuestions = `${base}/examinationQuestions/importExaminationQuestions` + `/` + parseInt(window.localStorage.getItem('projectId'))

//主数据管理
//教材管理

//
export const getTeachingMaterialInfoProjectList = params => {
    return axios.get(`${base}/teachingMaterialInfo/getTeachingMaterialInfoProjectList`, {params: params});
};

//获取教材树
export const getTeachingMaterialTree = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/teachingMaterialInfo/getTeachingMaterialTree`, {params: params});
};
export const getTeachingMaterialTreeOther = params => {
    return axios.get(`${base}/teachingMaterialInfo/getTeachingMaterialTree`, {params: params});
};

//同步教材章节至目录
export const getTeachingMaterialInfoSynchronization = params => {
    return axios.get(`${base}/teachingMaterialInfo/getTeachingMaterialInfoSynchronization`,  {params: params});
};


//获取两级考试卷纸教材信息树
export const getExamPaperTeachingMaterialTree = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationPaper/getExamPaperTeachingMaterialTree`, {params: params});
};


//新增教材信息
export const addTeachingMaterialInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/addTeachingMaterialInfo`,  params);
};

//更新教材信息
export const updateTeachingMaterialInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/updateTeachingMaterialInfo`,  params);
};

//删除教材信息
export const deleteTeachingMaterialInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/deleteTeachingMaterialInfo`,  params);
};

//根据教材ID获取视频分页集合
export const getTeachingMaterialVideoByTMIDListPageAsync = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/teachingMaterialInfo/getTeachingMaterialVideoByTMIDListPageAsync`, {params: params});
};
//建立教材与视频关联关系
export const relationTeachingVideo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/relationTeachingVideo`,  params);
};
//取消教材与视频关联关系
export const delRelationTeachingVideo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/teachingMaterialInfo/delRelationTeachingVideo`,  params);
};


//工作流管理

//审批
export const approve = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/WorkFlow/Approve`,  params);
};

//获取待处理信息分页列表
export const getPendingIssuesListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetPendingIssuesListPage`, {params: params});
};

//获取已处理信息分页列表
export const getProcessedIssuesListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetProcessedIssuesListPage`, {params: params});
};

//获取已发起信息分页列表
export const getLaunchIssuesListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetLaunchIssuesListPage`, {params: params});
};

//获取全部事项分页列表
export const getAllIssuesListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetAllIssuesListPage`, {params: params});
};

//根据审批记录ID获取试题审批记录详情
export const getExaminationQuestionsApprovalRecordByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetExaminationQuestionsApprovalRecordByID`, {params: params});
};

//根据审批记录ID获取发布考试项目详情
export const getPublishExamProjectInfoByID = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/WorkFlow/GetPublishExamProjectInfoById`, {params: params});
};


//考试管理
//考试项目

//获取考试项目分页列表
export const getExamProjectInfoListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationProject/getExamProjectInfoListPage`, {params: params});
};

//新增考试项目
export const addExamProjectInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/addExamProjectInfo`,  params);
};

//编辑考试项目
export const updateExamProjectInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/updateExamProjectInfo`,  params);
};

//删除考试项目
export const deleteExamProjectInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/deleteExamProjectInfo`,  params);
};

//发布考试项目
export const publishExamProjectInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/publishExamProjectInfo`,  params);
};

//取消发布考试项目
export const cancelExamProjectInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/handleCancelExamProject`,  params);
};



//考试管理
//试卷管理

//获取考试试卷分页列表
export const getExaminationPaperListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationPaper/getExaminationPaperListPage`, {params: params});
};

//根据试卷ID获取考试试卷信息
export const getExaminationPaperByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationPaper/getExaminationPaperById`, {params: params});
};

//新增考试试卷
export const addExaminationPaper = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationPaper/addExaminationPaper`,  params);
};

//编辑考试试卷
export const updateExaminationPaper = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationPaper/updateExaminationPaper`,  params);
};

//删除考试试卷
export const deleteExaminationPaper = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationPaper/deleteExaminationPaper`,  params);
};

//启用/禁用考试试卷
export const enableOrDisableExaminationPaper = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationPaper/enableOrDisableExaminationPaper`,  params);
};

//获取行业类型
export const getExamPaperInfoTradeTypeList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/ExamManage/GetExamPaperInfoTradeTypeList`, {params: params});
};
//考试管理
//获取二维码考试计划分页列表
export const getExamProjectInfoQRListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/getExamProjectInfoQRListPage`, {params: params});
};
//新增二维码考试计划
export const addExamProjectInfoQR = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentExam/addExamProjectInfoQR`,  params);
};
//修改二维码考试计划
export const updateExamProjectInfoQR = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentExam/updateExamProjectInfoQR`,  params);
};
//删除二维码考试计划
export const deleteExamProjectInfoQR = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentExam/deleteExamProjectInfoQR?projectId=${params.ProjectId}&id=${params.id}`,{});
};

// 获取人群
export const getSocialGroupList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupList`, {params: params});
};

// 获取二维码考试计划学员列表
export const getExamProjectInfoQRStaffList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/getExamProjectInfoQRStaffList`, {params: params});
};

// 新增二维码考试人员
export const addExamProjectInfoQRStaff = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/addExamProjectInfoQRStaff`, {params: params});
};





//考试管理
//仿真实操题量配置
//获取仿真实操题量配置基础数据
export const getPublicDictionaryList = params => {
    return axios.get(`${base}/dataDictionary/getPublicDictionaryList`, {params: params});
};
//更新仿真实操题量配置基础数据
export const updateFzscDataById = params => {
    return axios.get(`${base}/dataDictionary/updateFzscDataById`, {params: params});
};


//证书管理
//证书设计

//获取证书设计分页列表
export const getCertificateInfoListPage = params => {
    // params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/certificateDesign/getCertificateInfoListPage`, {params: params});
};

//新增证书设计
export const addCertificateInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/certificateDesign/addCertificateInfo`,  params);
};

//编辑证书设计
export const updateCertificateInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/certificateDesign/updateCertificateInfo`,  params);
};

//删除证书设计
export const deleteCertificateInfo = params => {
    params.ProjectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/certificateDesign/deleteCertificateInfo`,  params);
};

// 历史登记单位
export const getCertificateRegisterByIDList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/certificateRegister/getCertificateRegisterByIdList`, {params: params});
};

//证书管理
//已发证查询

//获取已发证分页列表
export const getIssuedCertificateInfoListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getIssuedCertificateInfoListPage`, {params: params});
};
//导出已发证列表
export const exportIssuedCertificateInfoListPageApi = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/exportIssuedCertificateInfoListPage`, {params: params,responseType: 'arraybuffer'});
};

//撤销证书
export const cancelIssuedCertificateInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/certificate/cancelIssuedCertificateInfo`,  params);
};

//证书管理
//发证审核

//获取发证审核分页列表
export const getCertificationReviewListPage = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/certificate/getCertificationReviewListPage`, {params: params});
};

//发证审核通过/驳回
export const examinationReview = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/certificate/examinationReview`, {params: params});
};

//发证批量审核通过/驳回
export const examinationReviewBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/certificate/examinationReviewBatch`,  params);
};

//获取抓拍照片列表
export const getTakePhotosList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticPaper/getTakePhotosList`, {params: params});
};
//获取人声监测列表
export const getRecordingMonitoringList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticPaper/getRecordingMonitoringList`, {params: params});
};


//学员考生管理
//账号管理

//获取学员考生账号分页列表
export const getStudentExamineeAccountListPage = params => {
    const router = JSON.parse(window.localStorage.getItem('router'))
    console.log(router,'router')
    if (router[0].name !== '首页'){
        params.projectId =parseInt(window.localStorage.getItem('projectId'))
    }
    return axios.get(`${base}/statisticStudent/getStudentAccountListPage`, {params: params});
};

//启用/禁用学员考生账号
export const enableOrDisableStudentExamineeAccount = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentAccount/enableOrDisableStudentExamineeAccount`,  params);
};

//学员考生管理
//档案管理

//获取学员考生档案分页列表
export const getStudentExamineeIdentityListPage = params => {
    const router = JSON.parse(window.localStorage.getItem('router'))
    console.log(router,'router')
    if (router[0].name !== '首页'){
        params.projectId =parseInt(window.localStorage.getItem('projectId'))
    }
    return axios.get(`${base}/statisticStudent/getExamEnrollListPage`, {params: params});
};

//修改学员考生档案信息
export const modifyStudentExamineeIdentity = params => {
    return axios.post(`${base}/studentAccount/modifyStudentExamineeIdentity`,  params);
};

//获取学员流向分页列表
export const getStudentLearnRecordPageList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getStudentLearnRecordPageList`, {params: params});
};


//学员考生管理
//考生报名信息

//获取学员考生报名信息分页列表
//24-02-05 从业人员管理-报考情况明细页面换下面新接口
export const getExamEnrollInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetExamEnrollInfoListPage`, {params: params});
};
export const getStudentExamEnrollListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/getStudentExamEnrollListPage`, {params: params});
};

//获取报考情况明细人员数量
export const getStudentExamEnrollCountApi = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentExamEnrollCount`, {params: params});
};


//新增学员考生报名信息
export const addStudentExamEnrollInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/AddStudentExamEnrollInfo`,  params);
};
export const submitStudentInformationByManger = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentExam/submitStudentInformationByManger`,  params);
};

//导入考生报名信息
export const importStudentExamEnrollInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/ImportStudentExamEnrollInfo`,  params);
};

//获取学员考生账号考试记录分页列表
export const getStudentExamineeAccountExamListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getStudentExamineeAccountExamListPage`, {params: params});
};

//获取学员考生账号学习记录分页列表
export const getStudentExamineeAccountStudyListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getStudentExamineeAccountStudyListPage`, {params: params});
};

//获取学员考生账号学习记录总时长
export const getLearnRecordByEnroll = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getLearnRecordByEnroll`, {params: params});
};

//获取学员考生账号练习记录分页列表
export const getStudentExamineeAccountTrainListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getStudentExamineeAccountTrainListPage`, {params: params});
};

// 导入考生报名信息
export const importStudentExamEnrollInfoUrl = `${base}/StudentExaminee/ImportStudentExamEnrollInfo`

//导出学员考生报名信息列表
export const exportExamEnrollInfo = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/ExportExamEnrollInfo`, {params: params});
};

//考生报名列表筛选考生后，可对考生生成批次
export const generateBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/GenerateBatch`,  params);
};

//加入批次
export const addBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/AddBatch`,  params);
};

// 修改允许考试
export const updateIsExemptTrain = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/ExamManage/UpdateIsExemptTrain`,  params);
};

// 发送短信
export const candidateSendsSMS = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/ExamManage/CandidateSendsSMS`,  params);
};

//考生学习档案
export const getStudentStudyArchivesListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentStudyArchivesListPage`, {params: params});
};

// 导出考生学习档案
// export const exportStudentStudyArchivesList = params => {
//     params.projectId =parseInt(window.localStorage.getItem('projectId'))
//     return axios.get(`${base}/statisticStudent/exportStudentStudyArchivesList`, {params: params,responseType: 'arraybuffer'});
// };

export const exportStudentStudyArchivesList = (params, onDownloadProgress) => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'));
    return axios.get(`${base}/statisticStudent/exportStudentStudyArchivesList`, {
        params: params,
        responseType: 'arraybuffer', // 保持原样，这对文件下载很重要
        onDownloadProgress: onDownloadProgress // 【关键】在这里接收进度回调
    });
};

//获取我的全部考试成绩分页列表
export const getAllMyStudentExamineePaperListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/paperStudent/getAllMyStudentExamineePaperListPage`, {params: params});
};

// 免培考试批次管理
//获取考生报名批次列表
export const getExamBatchPopulationList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/ExamManage/GetExamBatchPopulationList`, {params: params});
};

//删除考试批次
export const deleteExaminationBatch = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/ExamManage/DeleteExaminationBatch`,  params);
};

// 免培考试批次管理
// 考试申请审核

// 获取发送短信申请记录列表
export const getExamBatchMsgApplyRecordList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/ExamManage/getExamBatchMsgApplyRecordList`, {params: params});
};

// 获取发送短信名单详情列表
export const getExamBatchMsgDetailRecordList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/ExamManage/getExamBatchMsgDetailRecordList`, {params: params});
};

// 申请组织考试发送短信审核
export const reviewBatchMsg = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/ExamManage/reviewBatchMsg`,  params);
};

// 申请组织考试发送短信审核
export const checkMsg = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/ExamManage/Msg`,  params);
};

//学员考生管理
//考生汇总信息

//学员考生汇总查询分页列表
export const getStudentExamineeAggregateListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentExamineeAggregateListPage`, {params: params});
};

//行政区下属区域学员考生汇总查询列表
export const getStudentExamineeAggregateList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentExamineeAggregateList`, {params: params});
};

//学员考生管理
//成绩记录

//获取成绩记录分页列表
export const getStudentAchievementListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticPaper/getStudentAchievementListPage`, {params: params});
};

//删除考试记录
export const deleteStudentExamineePaperById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/paperStudent/deleteStudentExamineePaperById`,  params);
};

//从业人员管理
//报考资料审核

//获取报考资料审核分页列表
export const getStudentApprovePageList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/getStudentApprovePageList`, {params: params});
};

//报考资料审核通过
export const reviewStudentApprove = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/reviewStudentApprove`, {params: params});
};

//报考资料审核驳回
export const updateStudentApprove = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentExam/updateStudentApprove`,  params);
};

//报考资料删除
export const deleteStudentApprove = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/deleteStudentApprove`, {params: params});
};

//学员考生管理-培训机构专栏

// 培训机构考生报名信息
//获取培训机构考生报名信息
export const getExamEnrollInfoListPageNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentExamEnrollListPage`, {params: params});
};

//导出报考情况明细
export const exportStudentExamEnrollListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/exportStudentExamEnrollListPage`, {params: params,responseType: 'arraybuffer'});
};


//根据手机号获取该手机号是否是应训人员
export const getCheckIsSocialUnitStaff = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/CheckIsSocialUnitStaff`, {params: params});
};

// 培训机构考生汇总信息
//获取培训机构考生汇总信息
export const getStudentExamineeAggregateListPageNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentExamineeAggregateListPageNew`, {params: params});
};

// 培训机构成绩记录
//获取培训机构成绩记录
export const getStudentAchievementListPageNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/GetStudentAchievementListPageNew`, {params: params});
};

//上传临时文件
export const uploadTempFile = `${base}/image/uploadTempFile`

//图片管理

//上传图片
export const uploadTempPic = `${base}/image/uploadTempPic`
// 上传图片路径
export const uploadImagesUrl = `${base}/image/uploadTempPic`

// 上传图片路径-入参加token
export const uploadImgByEditor = `${base}/image/uploadImgByEditor`

//通知管理
//号码库

//获取号码库信息分页列表
export const getPhoneNumberLibraryListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeManage/GetPhoneNumberLibraryListPage`, {params: params});
};

//新增号码库信息
export const addPhoneNumberLibrary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeManage/AddPhoneNumberLibrary`,  params);
};

export const addPhoneNumberLibrary1 = `${base}/NoticeManage/AddPhoneNumberLibrary`

//编辑号码库信息
export const updatePhoneNumberLibrary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeManage/UpdatePhoneNumberLibrary`,  params);
};

export const updatePhoneNumberLibrary1 = `${base}/NoticeManage/UpdatePhoneNumberLibrary`

//删除号码库信息
export const deletePhoneNumberLibrary = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeManage/DeletePhoneNumberLibrary`,  params);
};

//获取号码库信息详情分页列表
export const getPhoneNumberLibraryDetailListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeManage/GetPhoneNumberLibraryDetailListPage`, {params: params});
};

//通知管理
//通知发送

//发送通知信息
export const addSendNotification = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeManage/AddSendNotification`,  params);
};

//通知管理
//通知记录

//获取通知记录分页列表
export const getNoticeRecordListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeManage/GetNoticeRecordListPage`, {params: params});
};

//获取通知记录详情分页列表
export const getNoticeRecordDetailListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeManage/GetNoticeRecordDetailListPage`, {params: params});
};


//持证监管
//社会单位明细

//获取社会单位信息分页列表
export const getSocialUnitListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getSocialUnitListPage`, {params: params});
};
//获取社会单位信息分页列表新接口
export const getSocialUnitListPageNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getSocialUnitListPageNew`, {params: params});
};

//根据单位id获取学员账号列表
export const getStudentAccountListBySocialUnitId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getStudentAccountListBySocialUnitId`, {params: params});
};

//根据单位id和项目id获取证书列表
export const getCertificateListBySocialUnitIdAndProjectId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}//statisticCert/getCertificateListBySocialUnitIdAndProjectId`, {params: params});
};

// 社会单位信息导出
export const exportSocialUnitListPageNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/exportSocialUnitListPageNew`, {params: params,responseType: 'arraybuffer'});
};

//获取社会单位信息分页列表-信息完整
export const getUnFinishedSocialUnitListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/getUnFinishedSocialUnitListPage`, {params: params});
};
export const getSociUnitById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetSociUnitById`, {params: params});
};

//获取社会单位信息分页列表1
export const getSocialUnitDataListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetSocialUnitDataListPage`, {params: params});
};


//根据社会单位ID获取单位证书登记详情分页列表
export const getCertificateRegisterBySocialUnitIDListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetCertificateRegisterBySocialUnitIDListPage`, {params: params});
};

//获取社会单位导入模板地址
export const getImportSocialUnitTemplateUrl = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetImportSocialUnitTemplateUrl`, {params: params});
};

let projectId = parseInt(window.localStorage.getItem('projectId'))

// 导入社会单位
export const importSocialUnit = `${base}/socialUnit/importSocialUnit/`+projectId
export const importSocialUnitStaff = `${base}/socialUnit/importSocialUnitStaff/`+projectId

//创建人群
export const addSocialGroup = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CrowdManagement/addSocialGroup`, params);
};

//导入报考学员名单
export const importExamEnrollInfo = params => {
    const projectId =parseInt(window.localStorage.getItem('projectId'))
    const departmentId =JSON.parse(window.localStorage.user).DepartmentId
    console.log("departmentId222",departmentId)
    return axios.post(`${base}/statisticStudent/importExamEnrollInfo/${projectId}/${departmentId}`,  params);
};

//获取单位人员列表
export const getSocialUnitStaffList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/socialStaff/getSocialUnitStaffList`, {params: params});
};

// 添加/编辑社会单位
export const saveSocialUnit = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/socialUnit/saveSocialUnit`,  params);
};

// 删除社会单位明细
export const deleteSocialUnitChaos = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/deleteSocialUnitChaos`,  params);
};

//同步社消平台
export const updateSxptDataService = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/updateSxptDataService`, {params: params});
};

//查看社消平台名单
export const getSxptExamTrainDetail = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/getSxptExamTrainDetail`, {params: params});
};

//删除社消平台名单
export const deletedDcSxptExamTrainDetail = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/deletedDcSxptExamTrainDetail`, {params: params});
};

// 持证监管
//大杂烩单位明细

// 获取社会单位大杂烩信息分页列表
export const getSocialUnitListPageChaos = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetSocialUnitListPageChaos`, {params: params});
};

// 获取社会单位大杂烩职员列表详情
export const getSocialUnitStaffListChaos = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetSocialUnitStaffListChaos`, {params: params});
};

//大杂烩应训人员
// 获取大杂烩应训人员分页列表
export const getSocialUnitStaffPageListChaos = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticUnit/getSocialUnitStaffPageList`, {params: params});
};

// 导出大杂烩应训人员分页列表
export const exportSocialUnitStaffPageListChaos = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/ExportSocialUnitStaffPageListChaos`, {params: params});
};

// 新增/编辑大杂烩应训人员
export const saveSocialUnitStaffChaos = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/SaveSocialUnitStaffChaos`,  params);
};

// 删除大杂烩应训人员
export const deleteSocialUnitStaffChaos = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/DeleteSocialUnitStaffChaos`, {params: params});
};

// 新旧应训人员融合
export const updateSocialUnitStaffByChaos = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/UpdateSocialUnitStaffByChaos`,  params);
};

// 新旧单位融合
export const updateSocialUnitByChaos = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/UpdateSocialUnitByChaos`,  params);
};

// 随机抽查下载excel
export const processAndReturnExcel = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/processAndReturnExcel`,  params);
};

// 随机抽查上传excel
export const uploadProcessAndReturnExcel = `${base}/StudentExaminee/processAndReturnExcel`


//持证监管
//待通知名单

//获取已通知名单列表
export const getNoticeBillList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetNoticeBillList`, {params: params});
};

//获取待通知名单数量
export const getToBeNoticeBillCount = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetToBeNoticeBillCount`, {params: params});
};

//生成最新通知名单
export const createNoticeBill = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/CreateNoticeBill`,  params);
};


//持证监管
//待处罚名单

//获取待处罚单位信息分页列表
export const getToBePunishSocialUnitListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetToBePunishSocialUnitListPage`, {params: params});
};

//处理社会单位
export const handleSocialUnit = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/LicensedSupervision/HandleSocialUnit`,  params);
};

//持证监管
//人群管理

//获取人群名单列表
export const getSocialGroupListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupListPage`, {params: params});
};

//获取人群名单列表只返回id和name
export const getSocialGroupName = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupList`, {params: params});
};

//查询单位人群名单
export const listForSocialUnit = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/listForSocialUnit`, {params: params});
};

//查询应训人员人群名单
export const listForSocialUnitStaff = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/noticeMange/listForSocialUnitStaff`, {params: params});
};

//查询短信模板
export const selectAllSmsTemplateName = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/notificeTemplate/getNoticeTemplateList`, {params: params});
};

//获取人群名单列表
export const getSocialGroupDetailListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupDetailListPage`, {params: params});
};

//删除人群管理
export const deleteSocialGroup = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/CrowdManagement/deleteSocialGroup`,  params);
};

//获取应训人员名单列表
export const getSocialGroupDetailListPageForStaff = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupDetailListPageForStaff`, {params: params});
};

//持证监管
//通知管理

//获取通知管理列表
export const listForNotificationManagement = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/noticeMange/listForNotificationManagement`, {params: params});
};

//获取发送短信成功/失败人数
export const listForSendSMS = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/noticeMange/listForSocialUnitStaff`, {params: params});
};

//审核通过
export const approved = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/noticeMange/approved`,  params);
};

//审核驳回
export const reviewFailed = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/noticeMange/reviewFailed`,  params);
};

//新建短信群发
export const applyForSendSMS = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/noticeMange/applyForSendSMS`,  params);
};

//重新发送短信
export const resendSMS = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/noticeMange/resendSMS`, {params: params});
};

//失败短信重发
export const failedSendSMSResend = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/noticeMange/failedSendSMSResend`, {params: params});
};

//持证监管
//应训人数

//获取应训人数分页列表
export const getSocialUnitStaffPageList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticUnit/getSocialUnitStaffPageList`, {params: params});
};
// 获取应训人员分页列表新接口
export const getSocialUnitStaffPageListNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getSocialUnitStaffPageListNew`, {params: params});
};
// 获取应训人群数量
export const getSocialUnitStaffCountNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getSocialUnitStaffCountNew`, {params: params});
};

// 应训人员导出
export const exportSocialUnitStaffPageListNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/exportSocialUnitStaffPageListNew`, {params: params,responseType: 'arraybuffer'});
};

//新增/编辑应训人数
export const saveSocialUnitStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/socialStaff/saveSocialUnitStaff`,  params);
};

//删除应训人数
export const deleteSocialUnitStaff = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/socialUnit/deleteSocialUnitStaff`, {params: params});
};

//社会单位汇总

//社会单位汇总查询分页列表
export const getSocialUnitAggregateListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticCert/getSocialUnitAggregateListPage`, {params: params});
};

//社会单位汇总统计
export const getSocialUnitAggregateTotal = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/LicensedSupervision/GetSocialUnitAggregateTotal`, {params: params});
};

// 持证监管
// 单位应训人员

// 获取单位应训人员列表
export const getSocialUnitChaosForMarketing = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CertificateManager/getSocialUnitChaosForMarketing`, {params: params});
};

// 获取填报执行人列表
export const getExecutorByUnitId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CertificateManager/getExecutorByUnitId`, {params: params});
};

// 获取本单位人员列表
export const getStaffsByUnitId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CertificateManager/getStaffsByUnitId`, {params: params});
};

// 获取学习时长大于0人数
export const getLearnStaffsByUnitId = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CertificateManager/getLearnStaffsByUnitId`, {params: params});
};

// 内部考试管理
// 内部试卷管理
// 获取内部试卷管理分页列表
export const getExamPaperInfoInternalSettingListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationPaper/getExamPaperInfoInternalSettingListPage`, {params: params});
};
// 编辑内部试卷
export const saveExamPaperInfoInternalSetting = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationPaper/saveExamPaperInfoInternalSetting`, {params: params});
};
// 内部考试计划
// 获取内部考试计划分页列表
export const getInternalExamProjectInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationProject/getInternalExamProjectInfoListPage`, {params: params});
};
//新增/编辑内部考试计划
export const saveInternalExamProjectInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/saveInternalExamProjectInfo`,  params);
};
// 删除内部考试计划
export const deleteInternalExamProjectInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/examinationProject/deleteInternalExamProjectInfo`,  params);
};
// 发布/取消发布内部考试计划
export const publishInternalExamProjectInfo = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/examinationProject/publishInternalExamProjectInfo`, {params: params});
};

//培训机构管理
//培训机构信息审核

//获取培训机构分页列表
export const getAgencyInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/agencyInfo/getAgencyInfoListPage`, {params: params});
};

//培训机构通过审核
export const approveAgencyInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/agencyInfo/approveAgencyInfo`,  params);
};

//关联品牌
export const relationBrand = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/AgencyManager/RelationBrand`,  params);
};

//删除培训机构
export const deleteAgencyInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/agencyInfo/deleteAgencyInfo`,  params);
};


//培训机构管理
//品牌管理

//获取品牌列表列表
export const getBrandListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/Brand/GetBrandListPage`, {params: params});
};

//新增品牌
export const addBrand = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/Brand/AddBrand`,  params);
};

//更新品牌
export const updateBrand = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/Brand/UpdateBrand`,  params);
};

//删除品牌
export const deleteBrand = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/Brand/DeleteBrand`,  params);
};

//培训机构管理
//变更记录

//获取变更记录列表
export const getLearnChangeListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/AgencyManager/getLearnChangeListPage`, {params: params});
};

//培训机构
//培训机构信息登记

//新增培训机构
export const addAgencyInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/agencyInfo/addAgencyInfo`,  params);
};

//编辑培训机构
export const updateAgencyInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/agencyInfo/updateAgencyInfo`,  params);
};

//获取培训机构详情
export const getAgencyInfo = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/agencyInfo/getAgencyInfo`, {params: params});
};



//培训机构
//学习记录管理

//获取学习记录分页列表
export const getStudentLearnRecordListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StatisticStudent/getStudentLearnRecordListPage`, {params: params});
};

//获取学习纪录导入模板地址
export const getImportStudentLearnRecordTemplateUrl = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/AgencyManager/GetImportStudentLearnRecordTemplateUrl`, {params: params});
};


// 导入学习纪录
export const importStudentLearnRecord = `${base}/AgencyManager/ImportStudentLearnRecord`

//问答管理
//问答类型

//获取问答类型集合
export const getQuestionAnswerTypeList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/questionAnswer/getQuestionAnswerTypeList`, {params: params});
};

//新增问答类型
export const addQuestionAnswerType = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/addQuestionAnswerType`,  params);
};

//更新问答类型
export const updateQuestionAnswerType = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/updateQuestionAnswerType`,  params);
};

//删除问答类型
export const deleteQuestionAnswerType = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/deleteQuestionAnswerType`,  params);
};


//问答管理
//问答信息


//获取问答信息分页列表
export const getQuestionAnswerInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/questionAnswer/getQuestionAnswerInfoListPage`, {params: params});
};

//新增问答信息
export const addQuestionAnswerInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/addQuestionAnswerInfo`,  params);
};

//更新问答信息
export const updateQuestionAnswerInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/updateQuestionAnswerInfo`,  params);
};

//删除问答信息
export const deleteQuestionAnswerInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/deleteQuestionAnswerInfo`,  params);
};

//推荐/取消推荐问答信息
export const recommendQuestionAnswerInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/questionAnswer/recommendQuestionAnswerInfo`,  params);
};


//问答管理
//在线留言

//获取在线留言分页列表
export const getOnlineMessageListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentMessage/getOnlineMessageListPage`, {params: params});
};


//删除在线留言
export const deleteOnlineMessage = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentMessage/deleteOnlineMessage`,  params);
};

//处理在线留言
export const handleOnlineMessage = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentMessage/handleOnlineMessage`,  params);
};

//修改在线留言备注
export const editOnlineMessageRemark = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentMessage/editOnlineMessageRemark`,  params);
};

//h5页面
//h5页面单位信息收集

// 发送验证码接口
// export const accessingPromotionalPages = params => {
//     return axios.post(`${base}/NoticeManage/AccessingPromotionalPages`,  params);
// };
export const accessingPromotionalPages = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeManage/AccessingPromotionalPages`, {params: params});
};

// 学员登录
export const studentCodeToken = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/login/StudentCodeToken`, {params: params});
};

// 发送验证码接口
export const sendSMSVerificationCode = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/SendSMSVerificationCode`,  params);
};

// 通过图形验证码发送短信验证码接口
export const sendSMSVerificationCodeWithVerify = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/SendSMSVerificationCodeWithVerify`,  params);
};

// 获取学员社会单位联系人状态
export const getStudentSocialUnitStatus = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentSocialUnitStatus`, {params: params});
};

// 获取岗位行业信息列表
export const getStationTradeList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/baseDictionary/getStationTradeList`, {params: params});
};

//学习报名信息启用禁用
export const changeStudentLearnRight = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentLearnRecord/changeStudentLearnRight`,  params);
};

//学习报名信息延长仿真次数
export const extendEnrollRightTimes = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/extendEnrollRightTimes`, {params: params});
};

// 批量新增单位消防人员
export const addSocialUnitStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/AddSocialUnitStaff`,  params);
};

// 批量新增大型商业综合体关联单位
export const addChildSocialUnit = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/AddChildSocialUnit`,  params);
};

// 获取社会单位消防人员接口
export const getStudentSocialUnitStaffList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentSocialUnitStaffList`, {params: params});
};

// 获取单位是否大型商业综合体及单位列表接口
export const getStudentChildSocialUnitList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentChildSocialUnitList`, {params: params});
};

// 获取省市区乡镇接口
export const getAreaDictionaryListNToken = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetAreaDictionaryList`, {params: params});
};

// 查询公司列表接口
export const getSocialUnitListByKeyWord = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/socialUnit/getSocialUnitListByKeyWord`, {params: params});
};
// 查询公司列表接口
export const getSocialUnitChaosListByKeyWord = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetSocialUnitChaosListByKeyWord`, {params: params});
};

// 添加公司和应训人员
export const addSocialUnitAndStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/StudentExaminee/AddSocialUnitAndStaff`,  params);
};

// 根据公司id获取公司和应训人员信息
export const getStudentSocialUnitById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentSocialUnitById`, {params: params});
};
// 根据公司id获取公司和应训人员信息
export const getStudentSocialUnitChaosById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetStudentSocialUnitChaosById`, {params: params});
};

// 上传excel分析人员的接口
export const analyseSocialUnitStaffChaos = `${base}/StudentExaminee/AnalyseSocialUnitStaffChaos`

// 首页数据详情
// 获取培训机构概况分页列表
export const getAgencyInfoBriefListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/AgencyManager/GetAgencyInfoBriefListPage`, {params: params});
};

// 获取参训人员分页列表
export const getLearnStudentInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/StudentExaminee/GetLearnStudentInfoListPage`, {params: params});
};

// 获取最新版app包
export const getNewAPPVersionInfo = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`/sstappwebapi/appVersion/getLatestAppVersion`, {params: params});
};

// 数据统计分析
// 统计分析
// 获取累计数量数据
export const getStatisticalOfAccumulatedQuantity = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/GetStatisticalOfAccumulatedQuantity`, {params: params});
};

// 获取趋势分析数据
export const trendAnalysisData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/TrendAnalysisData`, {params: params});
};
export const trendAnalysisDataNew = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/TrendAnalysisDataNew`, {params: params});
};

// 获取趋势分析柱状图
export const trendAnalysisDataOfCertificateRate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/TrendAnalysisDataOfCertificateRate`, {params: params});
};

// 获取趋势分析列表注册数量
export const getStudentAccountDetailByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getStudentAccountDetailByDate`, {params: params});
};

// 获取趋势分析列表报考数量
export const getStudentExamEnrollDetailByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getStudentExamEnrollDetailByDate`, {params: params});
};

// 获取趋势分析列表持证数量
export const getStudentCertificateDetailByDate = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getStudentCertificateDetailByDate`, {params: params});
};

// 考试情况分析
// 获取考试情况分析详情
export const getExaminationSituationAnalysisTotal = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getExaminationSituationAnalysisTotal`, {params: params});
};

// 获取考试情况分析列表
export const getExaminationSituationAnalysisDetail = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getExaminationSituationAnalysisDetail`, {params: params});
};

// 考核简报
// 获取周报月报概况数据分页列表
export const getAssessmentReport = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getAssessmentReport`, {params: params});
};

// 下载简报
export const downloadAssemenetReport = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/downloadAssemenetReport`, {params: params,responseType: 'arraybuffer'});
};

// 通知效果跟踪
// 新名单
// 获取可发短信总人数/待人工清洗数据
export const getNumOfDirResource = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNumOfDirResource`, {params: params});
};

// 获取发送短信批次数据
export const getBatchOfStatus = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getBatchOfStatus`, {params: params});
};

// 获取新名单/未访问H5页面发送通知概况预览
export const getDataOfBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getDataOfBatch`, {params: params});
};

// 获取新名单发送通知，响应率概况图表
export const getChartDataOfBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getChartDataOfBatch`, {params: params});
};

// 未访问H5页面
// 获取未访问H5页面实时数量
export const getCurDataByStatus = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getCurDataByStatus`, {params: params});
};

// 未访问H5页面选择人员查询
export const getSocialGroupNumByCondition = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CrowdManagement/getSocialGroupNumByCondition`, {params: params});
};

// 未访问H5申请发送短信
export const applyForStatusSendSMS = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeSms/applyForStatusSendSMS`,  params);
};

//查询短信模板
export const getNoticeTemplateByStatus = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNoticeTemplateByStatus`, {params: params});
};

// 待人工清洗数据
// 获取待人工清洗数据列表
export const getDataOfClean = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getDataOfClean`, {params: params});
};

// 编辑待人工清洗数据
export const updateDataOfClean = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeSms/updateDataOfClean`,  params);
};

// 访问后未填报员工信息单位数
// 获取访问后未填报员工信息单位数实时数量
export const getNoFillStaffData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNoFillStaffData`, {params: params});
};

// 访问后未填报员工信息单位数选择人员查询
export const getNoFillStaffByCondition = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNoFillStaffByCondition`, {params: params});
};

// 访问后未填报员工信息单位数申请发送短信
export const applyForSendStaffNoFill = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeSms/applyForSendStaffNoFill`,  params);
};

// 获取访问后未填报员工信息单位数发送通知概况预览
export const getNoFillDataOfBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNoFillDataOfBatch`, {params: params});
};

// 获取访问后未填报员工信息单位数图表
export const getNoFillChartOfBatch = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getNoFillChartOfBatch`, {params: params});
};

// 访问后未达到填报标准单位数
// 获取访问后未达到填报标准单位数实时数量
export const getLessFillStaffByCondition = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getLessFillStaffByCondition`, {params: params});
};

// 获取访问后未达到填报标准-可发通知单位数详情-可发通知人数
export const getLessFillStaffDetailByCondition = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getLessFillStaffDetailByCondition`, {params: params});
};

// 获取单位群体数据
export const getUnitFillSettingByType = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/getUnitFillSettingByType`, {params: params});
};

// 访问后未达到填报标准单位数申请发送短信
export const applyForSendStaffForFill = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeSms/applyForSendStaffForFill`,  params);
};

// 获取访问后未达到填报标准单位数的应训人员行业（场所）
export const getTradeByID = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/CommonSettings/getTradeByID`, {params: params});
};

// 新名单新增明细
// 获取新名单新增明细
export const getNewListSumData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getNewListSumData`, {params: params});
};

// 获取新名单新增明细列表
export const getNewListAddDetail = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/GeneralizationStatistics/getNewListAddDetail`, {params: params});
};

// 回执失败短信重发
// 获取回执失败短信重发列表
export const getReceiptFailData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/NoticeSms/getReceiptFailData`, {params: params});
};

// 回执失败短信重发
export const resendReceiptFailStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/NoticeSms/resendReceiptFailStaff`,  params);
};

//初始化项目
export const addInitialProject = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/project/addInitialProject`,  params);
};

//获取行政区域信息递归列表
export const getLoopAreaDictionary = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/areaDictionary/getLoopAreaDictionary`, {params: params});
};

//获取初始化后的项目配置列表
export const getInitialedProjectSettingsItem = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/project/getInitialedProjectSettingsItem`, {params: params});
};

// 获取单位列表
export const searchExtraItemByName = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/juheEnterprise/searchExtra`, {params: params});
};

//补充聚合企业信息
export const updateItem = params => {
    return axios.post(`${base}/juheEnterprise/updateItem`,  params);
}
//删除聚合企业信息
export const deleteExtraItem = params => {
    return axios.delete(`${base}/juheEnterprise/deleteExtraItem`,  {params: params});
}

// 项目-题库管理-视频管理
//获取视频列表
export const getVideoManageListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/videoManage/getVideoManageListPage`, {params: params});
};
//根据ID获取视频信息
export const getVideoInfoById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/videoManage/getVideoInfoById`, {params: params});
};
//获取视频播放码
export const getVideoPlaySafeCodeById = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/videoManage/getVideoPlaySafeCodeById`, {params: params});
};
//获取js上传视频参数
export const getVideoUploadParams = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/videoManage/getVideoUploadParams`, {params: params});
};
//新增视频
export const addVideoByCode = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/videoManage/addVideoByCode`,  params);
};
//编辑视频
export const updateVideoManage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/videoManage/updateVideoManage`,  params);
};
//删除视频
export const deleteVideoManage = params => {
    // params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/videoManage/deleteVideoManage`,   params);
};

//学习管理
//学习报名信息
export const getLearnRecordListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getLearnRecordListPage`, {params: params});
};
//学习记录详情
export const getStudyRecordDetail = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudyRecordDetail`, {params: params});
};
// 获取仿真实操学习记录
export const getFzscLearnRecordListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getFzscLearnRecordListPage`, {params: params});
};
// 改价
export const updateOrderInfoTotal = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}//statisticStudent/updateOrderInfoTotal`, {params: params});
};

//导出学生报名记录
export const exportLearnRecordListPageApi = params => {
     params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/exportLearnRecordListPage`, {params: params,responseType: "blob"} );
}

// 获取学员报名信息人群数量
export const getLearnRecordCountApi = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getLearnRecordCount`, {params: params} );
}

//添加学习报名信息或报考情况明细页面人群
export const addSocialGroupForExamAndEnrollApi = params => {
    params.ProjectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/statisticStudent/addSocialGroupForExamAndEnroll`,  params);
};

//上传凭证
export const addStudentExamEnrollInfoVoucherApi = params => {
    params.ProjectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/addStudentExamEnrollInfoVoucher`,  {params: params});
};

//更新学员考试报名信息缴费凭证状态
export const updateStudentExamEnrollInfoVoucherStatusApi = params => {
    params.ProjectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/updateStudentExamEnrollInfoVoucherStatus`,  {params: params});
};
//更新岗位行业信息
export const updateStationTradeId = params => {
    params.ProjectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/updateStationTradeId`,  {params: params});
};



//获取实操成绩分页列表
export const getStudentExamEnrollInfoPracticalPageApi = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentExamEnrollInfoPracticalPage`,  {params: params});
};

// 变更实操成绩状态
export const updatePracticalTotalScoreQualified = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/updatePracticalTotalScoreQualified`,  {params: params});
};

//导出实操成绩
export const exportStudentExamEnrollInfoPracticalApi = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/exportStudentExamEnrollInfoPractical`,  {params: params,responseType: 'arraybuffer'});
};

//获取签到记录分页列表
export const getStudentExamEnrollInfoSignPageApi = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentExamEnrollInfoSignPage`,  {params: params});
};

//导出签到记录
export const exportStudentExamEnrollInfoSignApi = params => {
    params.projectId = parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}//statisticStudent/exportStudentExamEnrollInfoSign`,  {params: params,responseType: 'arraybuffer'});
};




//单位协议缴费
//数据列表
export const getProtocolSocialUnitList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/protocol/getProtocolSocialUnitList`, {params: params});
};
//新增
export const saveProtocolSocialUnit = params => {
    
    return axios.post(`${base}/protocol/saveProtocolSocialUnit`,  params);
};

//获取学员列表
export const getProtocolStaffList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/protocol/getProtocolStaffList`, {params: params});
};
//添加学员
export const addProtocolStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/protocol/addProtocolStaff`,  params);
};
//变更学员
export const changeProtocolStaff = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/protocol/changeProtocolStaff`,  params);
};
//关联已报名学员
export const relateProtocol = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/protocol/relateProtocol`,  params);
};
//解绑
export const delRelateProtocol = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/protocol/delRelateProtocol`,  params);
};
//导入送培学员名单
export const importSocialUnitChaos = params => {
    const projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/protocol/inputProtocolList/${projectId}`,  params);
};
//删除协议
export const deleteProtocolSocialUnit = params => {
    return axios.post(`${base}/protocol/deleteProtocolSocialUnit`,   params);
}

//添加社会单位
export const addSocialUnitChaosByApp = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/socialUnit/addSocialUnitChaosByApp`,  params);
};
//关联已报名学员列表
export const getNoPayedAccountList = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/protocol/getNoPayedAccountList`, {params: params});
};
//获取单位协议人员pdf
export const getStaffForPDF = params => {
    const projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/protocol/getStaffForPDF/${projectId}`, {params: params});
};
export const muban = params => {
    return axios.get(`${base}/image/Protocol/muban.xlsx`, {params: params,responseType: 'arraybuffer'});
};


//邮寄教材
//获取邮寄记录列表
export const getlearningbookmailstatuslist = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentLearnRecord/getlearningbookmailstatuslist`, {params: params});
};
//管理员填写邮寄教材
export const managerFillAddress = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentLearnRecord/managerFillAddress`,  params);
};
//同步教材
export const syncPostInfo = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/studentLearnRecord/syncPostInfo`,  params);
};


//统计报告
//获取项目报告列表
export const getProjectReportListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticProject/getProjectReportListPage`, {params: params});
};
//生成项目报告
export const addProjectReport = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticProject/addProjectReport`, {params: params});
};
//获取项目内容
export const getProjectWordContent = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticProject/getProjectWordContent`, {params: params});
};
//保存项目内容
export const addProjectWordTitleContent = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/statisticProject/addProjectWordTitleContent`,  params);
};
//生成项目报告总报
export const downloadProjectReport = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticProject/downloadProjectReport`, {params: params,responseType: 'arraybuffer'});
};

export const getProjectInformation = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/project/getProjectData`, {params: params});
};
export const getStudentStudyArchivesSum = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticStudent/getStudentStudyArchivesSum`, {params: params});
};
//发票管理
//个人发票管理
export const getOrderInvoiceInfoListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/orderInvoiceInfo/getOrderInvoiceInfoListPage`, {params: params});
};
//导出开票信息
export const exportInvoiceInfoData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/orderInvoiceInfo/exportInvoiceInfoData`, {params: params,responseType: 'arraybuffer'});
};

//发票管理
//app收款明细
export const getReceiptOfAppListPage = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/orderInvoiceInfo/getReceiptOfAppListPage`, {params: params});
};
// 导出app收款信息
export const exportReceiptOfAppInfoData = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/orderInvoiceInfo/exportReceiptOfAppInfoData`, {params: params,responseType: 'arraybuffer'});
};
// 开票乐企发票接口
export const applyLeQiInvoice = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/orderInvoiceInfo/applyLeQiInvoice`,  params);
};


//获取试题
export const getCollectionQuestionsData = params => {
    return axios.get(`${base}/studyExamRecord/getCollectionQuestionsData`, {params: params});
};
//考生管理
//成绩查询-导出
export const getStudentAchievementListExcel = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/statisticPaper/getStudentAchievementListExcel`, {params: params,responseType: 'arraybuffer'});
}

export const getStudentByPhoneNumberAndCard = params => {
    params.projectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/studentExam/getStudentByPhoneNumberAndCard`, {params: params});
}


//获取文稿分页列表
export const getDocMaterialPageList = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/docMaterialManage/getDocMaterialPageList`, {params: params});
};
// 添加文稿资料
export const addDocMaterial = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/docMaterialManage/addDocMaterial`,  params);
};
// 修改文稿资料
export const updateDocMaterial = params => {
    params.ProjectId =parseInt(window.localStorage.getItem('projectId'))
    return axios.post(`${base}/docMaterialManage/updateDocMaterial`,  params);
};
//删除文稿资料
export const deleteDocMaterial = params => {
    params.projectId =  parseInt(window.localStorage.getItem('projectId'))
    return axios.get(`${base}/docMaterialManage/deleteDocMaterial`, {params: params});
};
// 上传pdf
export const uploadObsDocumentFile = `${base}/image/uploadObsDocumentFile`



